// HOOKS
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import useQuery from "../other/useQuery.other.hook";
// GRAPHQL
import { GET_AGING_REPORT } from "../../graphql/queries/tickets/agingReport.tickets.queries";
import convertToyyyyMMddThhmm from "../../utils/conversions/dates/yyyyMMddThhmm.date.conversion.util";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 0,
  sort: "-updated_at",
};

const useGetAgingTickets = () => {
  const [agingTickets, setAgingTickets] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [ticketInput, setTicketInput] = useState({});
  const [getAgingTicketsQuery, { loading, error }] = useLazyQuery(
    GET_AGING_REPORT,
    {
      fetchPolicy: "no-cache",
    }
  );
  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });

  const getAgingTickets = async () => {
    try {
      const res = await getAgingTicketsQuery({
        variables: { query, ticket: ticketInput },
      });
      if (res?.data?.tickets?.tickets) {
        setAgingTickets(
          res.data.tickets.tickets.map((ticket) => ({
            ...ticket,
          }))
        );
      }
      if (res?.data?.tickets?.metaData) setMetaData(res.data.tickets.metaData);
    } catch (error) {
      console.log(`Error getting aging tickets: ${error?.message}`);
      alert(`Error getting aging tickets: ${error?.message}`);
    }
  };

  useEffect(() => {
    if (Object.entries(ticketInput).length) {
      getAgingTickets();
    }
  }, [query, ticketInput]);

  return {
    agingTickets,
    metaData,
    setTicketInput,
    ticketInput,
    getAgingTickets,
    query,
    setQuery,
    loading,
    error,
  };
};

export default useGetAgingTickets;
